"use client";
import Image from "next/image";
import { useCallback, useEffect, useState } from "react";
import SelectInput from "../Shared/Form/SelectInput";
import { commonFetch } from "@/utils/commonFetch";

export default function ServicesFeesTable(cluster: any) {

  const [options, setOptions] = useState([]);
  const [countries, setCountries] = useState<any>([]);

  const [selectedCountryFees, setSelectedCountryFees] = useState([]);

  useEffect(() => {
    const fetchCountryFees = async () => {
      const repsonse = await commonFetch.get("country-fees")
      setCountries(repsonse)
      setOptions(
        repsonse?.map((item: any) => ({
          label: item.countryName,
          value: item.countryName,
        }))
      )
    }
    fetchCountryFees();
  }, [])

  const handleSelect = useCallback(
    (event: any) => {
      const selectedCountry = countries?.find(
        (country: any) => country.countryName === event
      );
      setSelectedCountryFees(selectedCountry ? selectedCountry?.FeesRow : []);
    },
    [countries]
  );


  return (
    <>
      <section className="w-screen max-w-full overflow-hidden relative h-[35rem]">
        <Image
          src="/assets/images/shared/triangle.png"
          alt="contact Form"
          className="right-0 absolute"
          width={900}
          height={700}
        />
        <h3 className="text-center mt-[5rem] mb-8 relative">
          {cluster?.title}
        </h3>
        <div className="shadow-cu px-[28px] pt-[20px] relative bg-white xl:w-[40%] md:w-[75%] h-auto mx-auto">
          <div className="traingle md:left-[20%] left-[15%] border-l-[25px] border-r-[25px] border-t-[15px] border-t-[#f1f1f1]"></div>
          <div className="mx-auto container relative z-10 md:w-full w-[80%] p-[15px]">
            <div className="flex justify-between md:flex-row flex-col">
              <div className="self-center">
                <p className="bdy-txt-5">All other countries fees list</p>
              </div>
              <div className="md:w-[40%] w-full">
                <SelectInput
                  options={options}
                  onSelect={handleSelect}
                  initialSelected={["Lebanon"]}
                  width={"100%"}
                  placeholder={"Select country"}
                />
              </div>
            </div>

            <div className="md:overflow-x-auto mt-4">
              <table className="min-w-full divide-y divide-gray-200 md:ml-0 -ml-[45px]">
                <thead className="bg-[#585858]">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                    >
                      From
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                    >
                      To
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider"
                    >
                      Fees
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {selectedCountryFees.map((fee: any, index: number) => (
                    <tr
                      key={index}
                      className={
                        index % 2 === 0 ? "bg-[#FAFAFA]" : "bg-[#E6E6E6]"
                      }
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        ${fee.from}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        ${fee.to}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        ${fee.fees}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <Image
        src={"/assets/images/shared/3-arrow-down.png"}
        alt=""
        width={80}
        height={100}
        className="absolute ml-[5rem] -mt-[4rem]"
      />
    </>
  );
}
